<template>
    <v-card
        v-if="!loading"
        flat
    >
        <v-card-text>
            <v-layout wrap>
                <v-flex
                    xs12
                    sm12
                    md4
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="lead.policy.PolicyMasterID"
                        label="ID"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    sm12
                    md4
                >

                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="lead.policy.PolicyMasterCode"
                        label="Code"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    sm12
                    md4
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="lead.policy.Status"
                        label="Status"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>


                <v-flex
                    xs12
                    sm12
                    md6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="lead.policy.CommencementDate"
                        label="Commencement"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    sm12
                    md6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="lead.policy.WillStatus"
                        label="Will Status"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>


                <v-flex
                    xs12
                >
                    <h3>Plan details</h3>
                </v-flex>

                <v-flex
                    xs12
                    sm12
                    md6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="lead.policy.plan_details.product_name"
                        label="Product"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    sm12
                    md6
                >
                    <v-text-field
                        class="title-branding custom-input"
                        filled
                        v-model="lead.policy.plan_details.product_plan"
                        label="Plan"
                        type="text"
                        readonly
                    ></v-text-field>
                </v-flex>

                <v-flex
                    xs12
                    sm12
                    md6
                >
                    <v-currency-field
                        class="title-branding custom-input"
                        label="Premium"
                        v-model="lead.policy.plan_details.premium"
                        v-bind="$root.currency_config"
                        type="tel"
                        filled
                        readonly
                    ></v-currency-field>
                </v-flex>

                <v-flex
                    xs12
                    sm12
                    md6
                >
                    <v-currency-field
                        class="title-branding custom-input"
                        label="Value to beneficiaries"
                        v-model="lead.policy.plan_details.value_beneficiaries_total"
                        v-bind="$root.currency_config_no_decimals"
                        type="tel"
                        filled
                        readonly
                    ></v-currency-field>
                </v-flex>
            </v-layout>
        </v-card-text>
    </v-card>
</template>
<script>
    export default {
        data() {
            return {
                loading: true,
                lead: {},
            }
        },

        props: ['itemInfo'],

        name: 'Lead-Policy',

        mounted() {
            this.lead = this.itemInfo;
            setTimeout(() => {
                this.loading = false;
            }, 100);
        },
    }
</script>
